import request from "@utils/request";

export function getDailySummary(query) {
    return request({
        url: "daily-summary",
        method: "post",
        data: query
    });
}
